module.exports = __webpack_public_path__ + "static/media/vineyard.ef128221.jpg";